module.exports = __webpack_public_path__ + "img/our5.b287a8f8.svg";